import { render, staticRenderFns } from "./DSServicesIcon.vue?vue&type=template&id=9659d4b6&scoped=true&"
import script from "./DSServicesIcon.vue?vue&type=script&lang=js&"
export * from "./DSServicesIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9659d4b6",
  null
  
)

export default component.exports